import { schema } from 'normalizr'
import { REDUCER_NAME_FEEDBACK_FORMS } from 'utils/enums/reducersNames'

export const feedbackFormsSchema = new schema.Entity(REDUCER_NAME_FEEDBACK_FORMS, {})
